import React, {FC, memo, useMemo} from 'react'
import {IEntityDetail} from '@redux/types'
import {isNotEmptyRichContent} from '@common/functions'
import EmbedMedia from '@components/common/EmbedMedia'
import Picture from '@components/common/Picture'
import Text from '@components/common/Text'
import RichTextContent from '@components/RichTextContent'
import Image from 'next/image'
import {MONTHS} from '@common/constants'

const DetailPageHeader: FC<IEntityDetail> = ({title, description, text, media, embed, tag, readingTime, datePublication}) => {
  const emptyText = useMemo(() => !isNotEmptyRichContent(text), [text])
  const isHeaderContentExist = !emptyText || description || media || embed

  const datePublications = (datePublication: string) => {
    const date = datePublication?.split('-') ?? ''
    const year = date[0]
    const month = MONTHS[date[1]]
    const day = date[1]?.replace(/^0+/, '')
    return `${day} ${month} ${year}`
  }

  return (
    <>
      {title && (
        <section className={isHeaderContentExist ? 'inner-title' : 'inner-title inner-title--margin-short'}>
          <div className="container">
            <h1 className={'inner-title__text'}>
              <Text text={title} />
            </h1>
          </div>
          {(readingTime || datePublication) && (
            <div className="inner-title__blog-info">
              {datePublication && <span className="inner-title__blog-info-text">{datePublications(datePublication!)} года</span>}
              {readingTime && (
                <div className="inner-title__blog-info-reading-time">
                  <Image src="/img/sprite/icon-clock.svg" alt="Часы" width={20} height={20} />
                  <span className="inner-title__blog-info-text">{readingTime} мин</span>
                </div>
              )}
            </div>
          )}
          {tag && (
            <div className="inner-title__tag">
              <span className="inner-title__tag-text">{tag.name}</span>
            </div>
          )}
        </section>
      )}
      {isHeaderContentExist && (
        <section className="inner-grid inner-grid--no-padding">
          <div className="container">
            <h2 className="visually-hidden">{title}</h2>
            {(!emptyText || description) && (
              <div className="inner-grid__content">
                <div className="inner-simple-text inner-simple-text--mobile-margin">
                  {emptyText ? <p>{description}</p> : <RichTextContent content={text || []} />}
                </div>
              </div>
            )}

            {media && <Picture media={media} wrapperClassName={'inner-picture--margin-top-big'} />}

            {embed && (
              <div className={'inner-grid__content-max'}>
                <EmbedMedia embed={embed} />
              </div>
            )}
          </div>
        </section>
      )}
    </>
  )
}

export default memo(DetailPageHeader)
